import { Link } from 'react-router-dom';
import { dailyUpdateComics } from '@/mocks/comics';

export default function DailyUpdate() {
  return (
    <section id="daily" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              今日更新
            </h2>
            <p className="mt-2 text-sm text-foreground-600">最新鲜的韩漫内容，每日同步韩国更新进度</p>
          </div>
          <Link
            to="/category/love"
            className="mt-3 md:mt-0 text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {dailyUpdateComics.map((comic, index) => (
            <Link
              key={comic.slug}
              to="/"
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="relative w-full h-[320px] md:h-[360px]">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={comic.title}
                  className="w-full h-full object-cover object-top"
                />
                {index === 0 && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold rounded-full bg-accent-500 text-white">
                    NEW
                  </span>
                )}
              </div>

              <div className="p-4 md:p-5 text-center">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1.5">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3">
                  更新至第{comic.chapters[0]?.number}话
                </p>
                <span
                  className={`inline-block w-full py-2.5 text-xs font-semibold rounded-full border transition-colors whitespace-nowrap ${
                    index === 0
                      ? 'bg-primary-500 text-white border-primary-500'
                      : 'bg-transparent text-foreground-700 border-foreground-300 hover:bg-primary-500 hover:text-white hover:border-primary-500'
                  }`}
                >
                  {index === 0 ? '立即阅读' : '开始阅读'}
                </span>
                <p className="mt-2 text-[11px] text-foreground-400">今日 {comic.updatedAt} 更新</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}